import SetlistDisplayOverlay from 'components/Setlist/SetlistDisplayOverlay';
import React from 'react';

const SetlistDisplayOverlayPage: React.FC = () => {
  return <SetlistDisplayOverlay />;
};

export default SetlistDisplayOverlayPage;
